module.exports = __webpack_public_path__ + "static/media/20GalleryPuppets.acacb66f.jpeg";